export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf04-mobile-de.666792a6.png";